import PropTypes from 'prop-types';

import { LANGUAGE_KEY } from 'constants/booking';
import { ADD_ADDITIONAL_DETAILS, UPDATE_ADDITIONAL_DETAILS } from 'store/mutations';
import { additionalDetailsShape, clientShape } from 'constants/propTypes';

const updateBookingLanguage = async (client, additionalDetails, reference, bookingLanguage) => {
  try {
    const activeBookingLanguage = additionalDetails?.find(({ key }) => key === LANGUAGE_KEY)?.value;

    if (client && reference && bookingLanguage && activeBookingLanguage !== bookingLanguage) {
      await client.mutate({
        mutation: activeBookingLanguage ? UPDATE_ADDITIONAL_DETAILS : ADD_ADDITIONAL_DETAILS,
        variables: {
          bookingReference: reference,
          additionalDetails: {
            key: LANGUAGE_KEY,
            value: bookingLanguage
          }
        }
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Cannot update booking language', error);
  }
};

updateBookingLanguage.propTypes = {
  apolloClient: clientShape,
  additionalDetails: additionalDetailsShape,
  reference: PropTypes.string,
  bookingLanguage: PropTypes.string
};

export default updateBookingLanguage;
